import React from "react";
import { ButtonTactil } from "./ButtonTactil";
import { Delete, X } from "react-feather";

export const KeyBoard = (props) => {
  const value = props.fieldValue;
  const changeValue = props.setFieldValue;
  const changeFlagDisability = props.setFlag;

  let number = 1;
  const listNumbers = Array.from({ length: 9 }, () => number++);
  const tactilNumbersComponents = listNumbers.map((num) => (
    <ButtonTactil
      key={num.toString()}
      data={num.toString()}
      styleBox="box-number"
      fieldValue={value}
      changeFieldValue={changeValue}
      setFlag={changeFlagDisability}
    />
  ));
  tactilNumbersComponents.push(
    <ButtonTactil
      key="delAll"
      command={"delAll"}
      data={<X size={18} />}
      styleBox="box-number"
      fieldValue={value}
      changeFieldValue={changeValue}
      setFlag={changeFlagDisability}
    />,
    <ButtonTactil
      key="0"
      data={0}
      styleBox="box-number"
      fieldValue={value}
      changeFieldValue={changeValue}
      setFlag={changeFlagDisability}
    />,
    <ButtonTactil
      key="del"
      command={"del"}
      data={<Delete size={18} />}
      styleBox="box-number"
      fieldValue={value}
      changeFieldValue={changeValue}
      setFlag={changeFlagDisability}
    />
  );
  return <div>{tactilNumbersComponents}</div>;
};
